import { Link, useLocation } from "react-router-dom";
import { Radio } from "lucide-react";
import { useConnectionStatus } from "@/hooks/useConnectionStatus";

export default function Header() {
  const online = useConnectionStatus();
  const location = useLocation();
  const isDetail = location.pathname.startsWith("/evento/");

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-40 border-b border-[#1E293B] bg-[#080D1A]/85 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 md:px-8">
        <Link
          to="/"
          data-testid="header-logo"
          className="group flex items-center gap-3"
        >
          <div className="flex h-11 w-11 items-center justify-center overflow-hidden bg-[#080D1A]">
            <img
              src="https://customer-assets-lxgj4vgw.emergentagent.net/job_myfire-battles/artifacts/41aefba8a1ad4cfb_pinza_logo_1.webp"
              alt="La Pinza"
              className="h-10 w-10 object-contain"
            />
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-display text-2xl tracking-wider text-white">
              LA PINZA
            </span>
            <span className="font-ui text-[10px] font-medium uppercase tracking-[0.3em] text-[#94A3B8]">
              Battle Arena
            </span>
          </div>
        </Link>

        <nav className="flex items-center gap-6">
          <Link
            to="/"
            data-testid="header-home"
            className="font-ui text-xs font-bold uppercase tracking-[0.2em] text-[#94A3B8] hover:text-[#FF5500]"
          >
            Inicio
          </Link>
          {isDetail && (
            <Link
              to="/eventos"
              data-testid="back-to-events"
              className="font-ui text-xs font-bold uppercase tracking-[0.2em] text-[#94A3B8] hover:text-[#FF5500]"
            >
              ← Eventos
            </Link>
          )}
          <div
            data-testid="connection-status"
            className="flex items-center gap-2 border border-[#1E293B] bg-[#0F172A] px-3 py-1.5"
          >
            <span
              className={`inline-block h-2 w-2 rounded-full ${
                online ? "bg-[#FF5500] live-pulse" : "bg-[#CC3300]"
              }`}
            />
            <Radio className="h-3.5 w-3.5 text-[#94A3B8]" />
            <span className="font-ui text-[10px] font-bold uppercase tracking-[0.2em] text-white">
              {online ? "En línea" : "Sin conexión"}
            </span>
          </div>
        </nav>
      </div>
    </header>
  );
}
